import { Link, useNavigate } from "react-router-dom";

/** Lib Imports */
import { Button } from "primereact/button";

/** CSS */
import "./UnauthorizedPage.scss";

const UnauthorizedPage = () => {

  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate("/");
  }

  return (
    <div className="not-found">
      
      <div className="error-img">
        <img className="big-logo" src="/images/unauthorize-page.png" alt="profileImg" />
      </div>
      <p className="error-title">Unauthorized Page</p>
      <p className="error-message">
        You do not have permission to view this page. <br></br>
        Please ensure you are logged in with the correct account.
      </p>

      <Button
        as={Link}
        size="large"
        variant="primary"
        onClick={handleNavigateHome}
        title="Go to Home Page"
        label="Go to Home Page"
        className="btn  btn secondary-btn"
      />
    </div>
  );
};

export default UnauthorizedPage;
